/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */

const mergeOptions = (DEFAULTS = {}, options = {}, $el) => {
  const opts = Object.assign({}, DEFAULTS, options, $el ? $el.data() : {});
  return opts;
};

export default mergeOptions;



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/merge-options.js